<template>

    <v-page fixed>

        <v-page-header title="Exports" icon="fas fa-arrow-circle-down" />

        <v-page-filters>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getExports" />
            <div></div>
        </v-page-filters>

        <v-page-body>
            <v-notice v-if="!models.length" title="No Exports Found" message="Your customer exports will appear here." />
            <v-list v-else>
                <v-export v-for="model in models" :key="model.id" :model="model" @deleted="getExports" />
            </v-list>
        </v-page-body>

    </v-page>

</template>

<script>

import Export from './components/Export';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-export': Export,
    },

    data() {
        return {
            models: [],
            params: {},
        }
    },

    mounted() {
        // Listen for updates.
        if (window.Echo) {
            window.Echo.private('project.' + this.project.id)
                .listen('.export.finished', e => {
                    this.getExports();
                });
        }

        // Get exports.
        this.getExports();
    },

    beforeDestroy() {
        if (window.Echo) window.Echo.leave('.export.finished');
    },

    computed: {

        empty() {
            return this.models.length === 0;
        },

    },

    methods: {

        getExports() {
            this.$store.commit('loading', true);
            ProjectApi.getExports(this.project.id, this.params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.models = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

    },

}

</script>
